/**
 * @generated SignedSource<<5c1fef5d3fb9e59852c1325020d307a9>>
 * @relayHash 3a8c740b11db4a3f5632d0b342d9f394
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cfd2bd2f07fd22e7344a305aeca12fff528a3dfe173fd72586cbaf01bee5f65a

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectPanelQuery$variables = {
  ari: string;
  isProjectNativeIntegrationEnabled: boolean;
  queryContext?: string | null | undefined;
};
export type ProjectPanelQuery$data = {
  readonly me: {
    readonly user: {
      readonly accountId: string;
      readonly id: string;
      readonly name: string;
      readonly picture: AGG$URL;
    } | null | undefined;
  };
  readonly projects_byId: {
    readonly canEditMembers: boolean | null | undefined;
    readonly contributors: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly userContributor: {
            readonly id: string;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly id: string;
    readonly owner: {
      readonly id: string;
    } | null | undefined;
    readonly url: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectActionsContent" | "ProjectContributesTo" | "ProjectContributors" | "ProjectCustomFields" | "ProjectFocusAreas" | "ProjectFollowers" | "ProjectJiraWork" | "ProjectLinks" | "ProjectOwner" | "ProjectPanelHeader" | "ProjectPanelTabs" | "ProjectStartDate" | "ProjectStatusField" | "ProjectTags" | "ProjectTargetDate" | "ProjectWorkTracked" | "RelatedProjects">;
  };
};
export type ProjectPanelQuery = {
  response: ProjectPanelQuery$data;
  variables: ProjectPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ari"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isProjectNativeIntegrationEnabled"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "queryContext"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "picture"
},
v4 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v5 = [
  {
    "kind": "Variable",
    "name": "projectId",
    "variableName": "ari"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "url"
},
v7 = [
  (v1/*: any*/)
],
v8 = {
  "kind": "ScalarField",
  "name": "canEditMembers"
},
v9 = {
  "kind": "Variable",
  "name": "queryContext",
  "variableName": "queryContext"
},
v10 = [
  (v9/*: any*/)
],
v11 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v12 = [
  (v11/*: any*/),
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/)
],
v13 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isUser"
},
v14 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "AtlassianAccountUserExtendedProfile",
      "kind": "LinkedField",
      "name": "extendedProfile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "jobTitle"
        }
      ]
    }
  ],
  "type": "AtlassianAccountUser"
},
v15 = {
  "kind": "ScalarField",
  "name": "count"
},
v16 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v17 = {
  "kind": "ScalarField",
  "name": "canEditMetadata"
},
v18 = {
  "kind": "ScalarField",
  "name": "canCreateUpdates"
},
v19 = {
  "kind": "ScalarField",
  "name": "dark"
},
v20 = {
  "kind": "ScalarField",
  "name": "light"
},
v21 = {
  "kind": "ScalarField",
  "name": "description"
},
v22 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v23 = {
  "kind": "ScalarField",
  "name": "endCursor"
},
v24 = {
  "kind": "ScalarField",
  "name": "key"
},
v25 = {
  "kind": "ScalarField",
  "name": "value"
},
v26 = [
  (v25/*: any*/)
],
v27 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "start"
    },
    {
      "kind": "ScalarField",
      "name": "end"
    }
  ]
},
v28 = {
  "kind": "ScalarField",
  "name": "summary"
},
v29 = [
  {
    "concreteType": "TownsquareLinkEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "TownsquareLink",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v6/*: any*/),
          (v2/*: any*/)
        ]
      }
    ]
  },
  (v16/*: any*/)
],
v30 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v31 = [
  (v24/*: any*/),
  (v1/*: any*/)
],
v32 = {
  "kind": "InlineFragment",
  "selections": (v7/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v33 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v34 = {
  "kind": "InlineFragment",
  "selections": (v7/*: any*/),
  "type": "AppUser"
},
v35 = {
  "kind": "InlineFragment",
  "selections": (v7/*: any*/),
  "type": "CustomerUser"
},
v36 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v37 = {
  "concreteType": "TownsquareCommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareCommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareComment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v11/*: any*/),
                (v2/*: any*/),
                (v1/*: any*/),
                (v4/*: any*/),
                (v3/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v36/*: any*/),
            (v33/*: any*/)
          ]
        }
      ]
    },
    (v16/*: any*/)
  ]
},
v38 = [
  {
    "kind": "ScalarField",
    "name": "label"
  },
  (v27/*: any*/)
],
v39 = [
  (v11/*: any*/),
  (v3/*: any*/),
  (v2/*: any*/),
  (v1/*: any*/)
],
v40 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v39/*: any*/)
},
v41 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": (v39/*: any*/)
},
v42 = {
  "kind": "ScalarField",
  "name": "lastEditedDate"
},
v43 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v28/*: any*/),
      (v21/*: any*/),
      (v40/*: any*/),
      (v41/*: any*/),
      (v33/*: any*/),
      (v42/*: any*/)
    ],
    "type": "TownsquareHighlight",
    "abstractKey": "__isTownsquareHighlight"
  }
],
v44 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v21/*: any*/)
],
v45 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v46 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v47 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v23/*: any*/),
    (v22/*: any*/)
  ]
},
v48 = {
  "kind": "ScalarField",
  "name": "canRemoveLinkedWorkItems"
},
v49 = {
  "kind": "ScalarField",
  "name": "canAddLinkedWorkItems"
},
v50 = {
  "kind": "ScalarField",
  "name": "webUrl"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ProjectPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ]
          }
        ]
      },
      {
        "kind": "RequiredField",
        "field": {
          "args": (v5/*: any*/),
          "concreteType": "TownsquareProject",
          "kind": "LinkedField",
          "name": "projects_byId",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v6/*: any*/),
            {
              "kind": "LinkedField",
              "name": "owner",
              "plural": false,
              "selections": (v7/*: any*/)
            },
            {
              "concreteType": "TownsquareContributorConnection",
              "kind": "LinkedField",
              "name": "contributors",
              "plural": false,
              "selections": [
                {
                  "concreteType": "TownsquareContributorEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "concreteType": "TownsquareContributor",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "userContributor",
                          "plural": false,
                          "selections": (v7/*: any*/)
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            (v8/*: any*/),
            {
              "condition": "isProjectNativeIntegrationEnabled",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": (v10/*: any*/),
                  "kind": "FragmentSpread",
                  "name": "ProjectJiraWork"
                }
              ]
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectPanelHeader"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectTags"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectTargetDate"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectStatusField"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectOwner"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectLinks"
            },
            {
              "condition": "isProjectNativeIntegrationEnabled",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "ProjectWorkTracked"
                }
              ]
            },
            {
              "args": (v10/*: any*/),
              "kind": "FragmentSpread",
              "name": "ProjectFocusAreas"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectStartDate"
            },
            {
              "kind": "FragmentSpread",
              "name": "RelatedProjects"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectContributesTo"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectContributors"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectFollowers"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectActionsContent"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectPanelTabs"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectCustomFields"
            }
          ]
        },
        "action": "THROW",
        "path": "projects_byId"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v5/*: any*/),
        "concreteType": "TownsquareProject",
        "kind": "LinkedField",
        "name": "projects_byId",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v6/*: any*/),
          {
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": (v12/*: any*/)
          },
          {
            "concreteType": "TownsquareContributorConnection",
            "kind": "LinkedField",
            "name": "contributors",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareContributorEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareContributor",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "userContributor",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v1/*: any*/),
                          (v4/*: any*/),
                          (v13/*: any*/),
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v14/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareTeamContributor",
                        "kind": "LinkedField",
                        "name": "teamContributor",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "contributingMembers",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v11/*: any*/),
                                      (v4/*: any*/),
                                      (v1/*: any*/),
                                      (v13/*: any*/),
                                      (v2/*: any*/),
                                      (v3/*: any*/),
                                      (v14/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v15/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TeamV2",
                            "kind": "LinkedField",
                            "name": "team",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "displayName"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "smallAvatarImageUrl"
                              },
                              {
                                "concreteType": "TeamMemberConnectionV2",
                                "kind": "LinkedField",
                                "name": "members",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TeamMemberEdgeV2",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TeamMemberV2",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "member",
                                            "plural": false,
                                            "selections": (v12/*: any*/)
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "profileUrl"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "state"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "permission"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v16/*: any*/)
            ]
          },
          (v8/*: any*/),
          (v2/*: any*/),
          {
            "concreteType": "TownsquareProjectCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canAddTags"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveTags"
              },
              {
                "kind": "ScalarField",
                "name": "canEditTargetDate"
              },
              {
                "kind": "ScalarField",
                "name": "canEditStatus"
              },
              {
                "kind": "ScalarField",
                "name": "canManageOwnership"
              },
              {
                "kind": "ScalarField",
                "name": "canAddLinkedFocusAreas"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedFocusAreas"
              },
              {
                "kind": "ScalarField",
                "name": "canEditStartDate"
              },
              {
                "kind": "ScalarField",
                "name": "canAddContributors"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveContributors"
              },
              {
                "kind": "ScalarField",
                "name": "canAddWatchers"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveWatchers"
              },
              (v18/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canEditUpdates"
              },
              {
                "kind": "ScalarField",
                "name": "canDeleteUpdates"
              },
              {
                "kind": "ScalarField",
                "name": "canEditCustomFields"
              }
            ]
          },
          {
            "concreteType": "TownsquareWorkspace",
            "kind": "LinkedField",
            "name": "workspace",
            "plural": false,
            "selections": (v7/*: any*/)
          },
          {
            "concreteType": "TownsquareIconURIs",
            "kind": "LinkedField",
            "name": "iconUrl",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareThemeURIs",
                "kind": "LinkedField",
                "name": "roundedSquare",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  (v20/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareTagConnection",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareTagEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareTag",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "usageCount"
                      },
                      (v21/*: any*/)
                    ]
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v22/*: any*/),
                  (v23/*: any*/)
                ]
              },
              (v16/*: any*/)
            ]
          },
          (v24/*: any*/),
          {
            "kind": "ScalarField",
            "name": "isArchived"
          },
          {
            "concreteType": "TownsquareProjectState",
            "kind": "LinkedField",
            "name": "state",
            "plural": false,
            "selections": (v26/*: any*/)
          },
          {
            "concreteType": "TownsquareTargetDate",
            "kind": "LinkedField",
            "name": "dueDate",
            "plural": false,
            "selections": [
              (v27/*: any*/),
              {
                "kind": "ScalarField",
                "name": "confidence"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "startDate"
          },
          {
            "concreteType": "TownsquareProjectUpdateConnection",
            "kind": "LinkedField",
            "name": "updates",
            "plural": false,
            "selections": [
              (v16/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "watcherCount"
          },
          {
            "concreteType": "TownsquareProjectUpdate",
            "kind": "LinkedField",
            "name": "latestUserUpdate",
            "plural": false,
            "selections": [
              (v28/*: any*/),
              {
                "concreteType": "TownsquareUpdateNoteConnection",
                "kind": "LinkedField",
                "name": "updateNotes",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareUpdateNoteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareUpdateNote",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v28/*: any*/),
                          (v21/*: any*/),
                          (v1/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v1/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareLinkConnection",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": (v29/*: any*/)
          },
          {
            "args": (v10/*: any*/),
            "concreteType": "GraphStoreSimplifiedFocusAreaHasProjectInverseConnection",
            "kind": "LinkedField",
            "name": "focusAreas",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedFocusAreaHasProjectInverseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v30/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "userPermissions"
                          },
                          (v2/*: any*/),
                          (v6/*: any*/),
                          {
                            "concreteType": "MercuryFocusAreaStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": (v31/*: any*/)
                          },
                          {
                            "concreteType": "MercuryFocusAreaHealth",
                            "kind": "LinkedField",
                            "name": "health",
                            "plural": false,
                            "selections": (v31/*: any*/)
                          }
                        ],
                        "type": "MercuryFocusArea"
                      },
                      (v32/*: any*/)
                    ]
                  },
                  (v1/*: any*/)
                ]
              },
              (v16/*: any*/)
            ]
          },
          (v33/*: any*/),
          {
            "concreteType": "TownsquareProjectDependencyConnection",
            "kind": "LinkedField",
            "name": "dependencies",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectDependencyEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareProjectDependency",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "linkType"
                      },
                      {
                        "concreteType": "TownsquareProject",
                        "kind": "LinkedField",
                        "name": "incomingProject",
                        "plural": false,
                        "selections": (v7/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareProject",
                        "kind": "LinkedField",
                        "name": "outgoingProject",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v24/*: any*/),
                          (v2/*: any*/),
                          (v6/*: any*/),
                          {
                            "concreteType": "TownsquareIconURIs",
                            "kind": "LinkedField",
                            "name": "iconUrl",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareThemeURIs",
                                "kind": "LinkedField",
                                "name": "square",
                                "plural": false,
                                "selections": [
                                  (v20/*: any*/),
                                  (v19/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v16/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareProjectCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canAddRelatedProjects"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveRelatedProjects"
              },
              {
                "kind": "ScalarField",
                "name": "canAddLinkedGoals"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedGoals"
              },
              (v17/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canCommentOnProject"
              },
              (v18/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canCommentOnUpdates"
              }
            ]
          },
          {
            "concreteType": "TownsquareGoalConnection",
            "kind": "LinkedField",
            "name": "goals",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v6/*: any*/),
                      (v2/*: any*/),
                      {
                        "concreteType": "TownsquareStatus",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": (v26/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareGoalType",
                        "kind": "LinkedField",
                        "name": "goalType",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalTypeIcon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                              (v24/*: any*/)
                            ]
                          },
                          (v1/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v16/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareProjectAccessConnection",
            "kind": "LinkedField",
            "name": "access",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectAccessEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "role"
                  },
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v7/*: any*/),
                        "type": "User",
                        "abstractKey": "__isUser"
                      },
                      (v34/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v7/*: any*/),
                        "type": "AtlassianAccountUser"
                      },
                      (v35/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "isPrivate"
          },
          {
            "concreteType": "TownsquareUserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              {
                "concreteType": "TownsquareUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v1/*: any*/),
                      (v3/*: any*/),
                      (v2/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareProjectDescription",
            "kind": "LinkedField",
            "name": "description",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "what"
              },
              {
                "kind": "ScalarField",
                "name": "why"
              },
              {
                "kind": "ScalarField",
                "name": "measurement"
              }
            ]
          },
          (v37/*: any*/),
          {
            "concreteType": "TownsquareProjectUpdateConnection",
            "kind": "LinkedField",
            "name": "updates",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareProjectUpdate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "ari"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "missedUpdate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "updateType"
                      },
                      (v28/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v1/*: any*/),
                          (v4/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "newDueDate",
                        "plural": false,
                        "selections": (v38/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareProjectState",
                        "kind": "LinkedField",
                        "name": "newState",
                        "plural": false,
                        "selections": (v26/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "name": "lastEditedBy",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v4/*: any*/),
                          (v2/*: any*/),
                          (v1/*: any*/)
                        ]
                      },
                      (v33/*: any*/),
                      (v36/*: any*/),
                      (v6/*: any*/),
                      {
                        "concreteType": "GraphStoreSimplifiedUserViewedProjectUpdateInverseConnection",
                        "kind": "LinkedField",
                        "name": "viewers",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GraphStoreSimplifiedUserViewedProjectUpdateInverseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v1/*: any*/),
                                      (v2/*: any*/)
                                    ],
                                    "type": "AtlassianAccountUser"
                                  },
                                  (v34/*: any*/),
                                  (v35/*: any*/)
                                ]
                              },
                              (v1/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "TownsquareProjectState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": (v26/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "oldDueDate",
                        "plural": false,
                        "selections": (v38/*: any*/)
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDateConfidence"
                      },
                      {
                        "concreteType": "TownsquareUpdateNoteConnection",
                        "kind": "LinkedField",
                        "name": "updateNotes",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareUpdateNoteEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareUpdateNote",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  (v28/*: any*/),
                                  (v21/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "archived"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "TownsquareHighlightConnection",
                        "kind": "LinkedField",
                        "name": "highlights",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareHighlightEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v28/*: any*/),
                                  (v21/*: any*/),
                                  (v11/*: any*/),
                                  (v1/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isTownsquareHighlight"
                                  },
                                  (v40/*: any*/),
                                  (v41/*: any*/),
                                  (v33/*: any*/),
                                  (v42/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v16/*: any*/)
                        ]
                      },
                      (v37/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareHighlightEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v1/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v43/*: any*/),
                        "type": "TownsquareLearning"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v43/*: any*/),
                        "type": "TownsquareRisk"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v43/*: any*/),
                        "type": "TownsquareDecision"
                      }
                    ]
                  }
                ]
              },
              (v16/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareCustomFieldConnection",
            "kind": "LinkedField",
            "name": "customFields",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareCustomFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v30/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v44/*: any*/),
                                "type": "TownsquareTextCustomFieldDefinition"
                              },
                              (v32/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "alias": "textValue",
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          }
                        ],
                        "type": "TownsquareTextCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v30/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v44/*: any*/),
                                "type": "TownsquareNumberCustomFieldDefinition"
                              },
                              (v32/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareCustomFieldNumberSavedValueNode",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "alias": "numberValue",
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          }
                        ],
                        "type": "TownsquareNumberCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v30/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v44/*: any*/),
                                "type": "TownsquareUserCustomFieldDefinition"
                              },
                              (v32/*: any*/)
                            ]
                          },
                          {
                            "args": (v45/*: any*/),
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v11/*: any*/),
                                      (v1/*: any*/),
                                      (v13/*: any*/),
                                      (v2/*: any*/),
                                      (v3/*: any*/)
                                    ]
                                  },
                                  (v46/*: any*/)
                                ]
                              },
                              (v47/*: any*/),
                              (v16/*: any*/)
                            ],
                            "storageKey": "values(first:100)"
                          },
                          {
                            "args": (v45/*: any*/),
                            "handle": "connection",
                            "key": "CustomFieldUser_values",
                            "kind": "LinkedHandle",
                            "name": "values"
                          }
                        ],
                        "type": "TownsquareUserCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v30/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v1/*: any*/),
                                  (v2/*: any*/),
                                  (v21/*: any*/),
                                  {
                                    "args": (v45/*: any*/),
                                    "concreteType": "TownsquareCustomFieldTextAllowedValueConnection",
                                    "kind": "LinkedField",
                                    "name": "allowedValues",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareCustomFieldTextAllowedValueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareCustomFieldTextAllowedValueNode",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v1/*: any*/),
                                              (v25/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": "allowedValues(first:100)"
                                  }
                                ],
                                "type": "TownsquareTextSelectCustomFieldDefinition"
                              },
                              (v32/*: any*/)
                            ]
                          },
                          {
                            "args": (v45/*: any*/),
                            "concreteType": "TownsquareCustomFieldTextSavedValueConnection",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareCustomFieldTextSavedValueEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v1/*: any*/),
                                      {
                                        "alias": "selectValue",
                                        "kind": "ScalarField",
                                        "name": "value"
                                      },
                                      (v11/*: any*/)
                                    ]
                                  },
                                  (v46/*: any*/)
                                ]
                              },
                              (v47/*: any*/),
                              (v16/*: any*/)
                            ],
                            "storageKey": "values(first:100)"
                          },
                          {
                            "args": (v45/*: any*/),
                            "handle": "connection",
                            "key": "CustomFieldTextSelect_values",
                            "kind": "LinkedHandle",
                            "name": "values"
                          }
                        ],
                        "type": "TownsquareTextSelectCustomField"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "isProjectNativeIntegrationEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "TownsquareProjectCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  (v48/*: any*/),
                  (v49/*: any*/)
                ]
              },
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 5
                  },
                  (v9/*: any*/)
                ],
                "concreteType": "GraphStoreSimplifiedAtlasProjectTrackedOnJiraWorkItemConnection",
                "kind": "LinkedField",
                "name": "linkedJiraWorkItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      (v22/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "GraphStoreSimplifiedAtlasProjectTrackedOnJiraWorkItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v1/*: any*/),
                              (v50/*: any*/),
                              (v28/*: any*/),
                              {
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "permission",
                                    "value": "EDIT_ISSUES"
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "hasProjectPermission",
                                "storageKey": "hasProjectPermission(permission:\"EDIT_ISSUES\")"
                              },
                              {
                                "concreteType": "JiraStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "statusId"
                                  },
                                  (v2/*: any*/),
                                  {
                                    "concreteType": "JiraStatusCategory",
                                    "kind": "LinkedField",
                                    "name": "statusCategory",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "statusCategoryId"
                                      },
                                      (v2/*: any*/),
                                      (v1/*: any*/)
                                    ]
                                  },
                                  (v1/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "issueTypeId"
                                  },
                                  (v2/*: any*/),
                                  (v1/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraIssue"
                          },
                          (v32/*: any*/)
                        ]
                      },
                      (v1/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "isProjectNativeIntegrationEnabled",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": "workTrackingLinks",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  },
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "WORK_TRACKING"
                  }
                ],
                "concreteType": "TownsquareLinkConnection",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": (v29/*: any*/),
                "storageKey": "links(first:1,type:\"WORK_TRACKING\")"
              },
              {
                "concreteType": "TownsquareFusionDetails",
                "kind": "LinkedField",
                "name": "fusion",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "synced"
                  },
                  {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "issue",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v24/*: any*/),
                      (v50/*: any*/)
                    ]
                  }
                ]
              },
              {
                "concreteType": "TownsquareProjectCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  (v49/*: any*/),
                  (v48/*: any*/)
                ]
              }
            ]
          },
          (v16/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "cfd2bd2f07fd22e7344a305aeca12fff528a3dfe173fd72586cbaf01bee5f65a",
    "metadata": {},
    "name": "ProjectPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7a06e30df54e18409b5bcb3246f1a2cf";

export default node;
